import { useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Textarea } from 'core-components/library/inputs'

import tr from './translations'

import styles from './DisablingWarningDialogContent.module.scss'

interface IProps {
  disablingComment: string
  minCommentLength: number
  flagTag: string

  onApply: (value: string) => Promise<void>
  onCancel: () => void
}

export const DisablingWarningDialogContent = ({
  disablingComment,
  minCommentLength,
  flagTag,
  onApply,
  onCancel,
}: IProps) => {
  /** -------------------- State ----------------------- */

  const [value, setValue] = useState<string>(disablingComment || '')

  /** -------------------- Variables ----------------------- */

  const disableApply = useMemo(
    () => (value || '').length < minCommentLength,
    [value, minCommentLength]
  )

  const headerTag = `${flagTag}-${tr.suffix}-header`

  return (
    <div>
      <p>
        <Translation text={headerTag} />
      </p>
      <p>
        <Textarea
          rows={3}
          placeholder={tr.commentPlaceholder}
          value={value}
          onChange={(val: string) => setValue(val)}
        />
      </p>
      <footer className={styles.footer}>
        <Button
          disabled={disableApply}
          className={styles.button}
          color="danger"
          onClick={() => {
            onApply(value)
          }}
        >
          <Translation text={tr.apply} />
        </Button>
        <Button color="grey" className={styles.button} onClick={onCancel}>
          <Translation text={tr.cancel} />
        </Button>
      </footer>
    </div>
  )
}
